import { Component } from '@angular/core';

@Component({
  selector: 'request-sent-placeholder',
  templateUrl: './request-sent-placeholder.component.html',
  styleUrl: './request-sent-placeholder.component.scss',
  standalone: false,
})
export class RequestSentPlaceholderComponent {}
